import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  InputBase,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import Fuse from "fuse.js";
import SearchNotFound from "../../../components/emptyStyles/SearchNotFound";
import { Sales } from "../../../models/settlement.model";
import TabsEmptyStyle from "../../permission/components/TabsEmptyStyle";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const columns = [
  {
    id: 0,
    title: "نام فروشنده",
  },
  {
    id: 1,
    title: "نام متقاضی",
  },
  {
    id: 2,
    title: "کد ملی متقاضی",
  },
  {
    id: 3,
    title: "تاریخ فروش",
  },
  {
    id: 4,
    title: "مبلغ فاکتور (ریال)",
  },
  {
    id: 5,
    title: "مبلغ تسویه (ریال)",
  },

  {
    id: 6,
    title: "شماره شبا پذیرنده",
  },
  {
    id: 7,
    title: "نام صاحب حساب",
  },
  {
    id: 8,
    title: "نوع فروش",
  },
];

interface Props {
  count: number;
  sales: Sales[];
  handleRowClick: (
    key: string,
    branchId: number,
    customerPersonId: number
  ) => void;
}

const SupplierSettelmentRequestDetailTable = ({
  count,
  sales,
  handleRowClick,
}: Props) => {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };

  const fuse = new Fuse(sales, {
    keys: ["branchName", "customerName", "customerNationalCode", "iban"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const searchedResults = searchTerm
    ? results.map((title) => title.item)
    : sales;
  return (
    <div style={{ height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontSize: "1rem", fontWeight: "bold", color: "#1D4A87" }}
        >
          لیست منتخب تسویه{" "}
          <span style={{ fontWeight: "normal" }}>( {count} مورد)</span>
        </Typography>
        <Paper
          elevation={0}
          style={{
            border: "1px solid #DAE0E4",
            display: "flex",
            borderRadius: "5px",
            height: "35px",
            width: "20vw",
          }}
          square={true}
        >
          <InputBase
            sx={{
              ml: 1,
              flex: 1,
              paddingX: "16px",
              height: "30px !important",
            }}
            placeholder="جستجو"
            onChange={handleSearchInput}
          />

          <IconButton
            type="button"
            sx={{ color: "#9AAFC4" }}
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </Paper>
      </Box>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "80vh", height: "100%" }}
      >
        {sales.length > 0 ? (
          <Table
            stickyHeader
            sx={{
              minWidth: { xs: 0, sm: 0, md: 700, lg: 900 },
            }}
            aria-label="customized table"
          >
            <TableHead>
              <TableRow>
                {columns.length > 0 &&
                  columns.map((column) => (
                    <StyledTableCell align="center">
                      {column.title}
                    </StyledTableCell>
                  ))}
              </TableRow>
            </TableHead>

            <TableBody
              sx={{
                outline: "1px solid #DAE0E4",
              }}
            >
              {searchedResults?.length > 0 ? (
                searchedResults?.map((item: Sales, index) => (
                  <StyledTableRow
                    key={index}
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      handleRowClick(
                        item.key,
                        item.branchId,
                        item.customerPersonId
                      )
                    }
                  >
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.branchName}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.customerName}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.customerNationalCode}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.saleDatePersian}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.factorAmount?.toLocaleString("fa")}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.settlementAmount?.toLocaleString("fa")}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.iban}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.ibanOwner}
                      </p>
                    </StyledTableCell>
                    <StyledTableCell align="center" component="th" scope="row">
                      <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
                        {item?.saleType_Persian}
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <Box sx={{ width: "100%", height: "100%" }}>
                  <SearchNotFound />
                </Box>
              )}
            </TableBody>
          </Table>
        ) : (
          <TabsEmptyStyle height="43vh" completeText="موردی یافت نشده است" />
        )}
      </TableContainer>
    </div>
  );
};

export default SupplierSettelmentRequestDetailTable;
